


















































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import FooterFixedHandler from '@/mixins/FooterFixedHandler'
import {Form, FormItem, Radio} from 'element-ui'
import FloatingLabelInput from '@/components/FloatingLabelInput.vue'
import {ExtraData} from '@/store/modules/issue/types'
import {initExtraData} from '@/pages/issue/constants/init-extra-data'

@Component({
  components: {
    [Form.name]: Form, [FormItem.name]: FormItem, [Radio.name]: Radio,
    FloatingLabelInput,
  },
})
export default class ConfirmForm extends Mixins(Translation, FooterFixedHandler) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: () => ({}), type: Object}) value: ExtraData
  @Prop({default: false, type: Boolean}) isTotalAmountError: boolean

  data: ExtraData = initExtraData

  get defaultNumericOptions(): object {
    return {
      type: 'tel',
      separator: ',',
      minus: true,
      currency: `${this.ts('currency')}`,
      currencySymbolPosition: 'suffix',
      inputElType: 'vue-numeric',
    }
  }

  totalAmountErrorMessage(value): string {
    const {ts} = this
    if(value && this.isTotalAmountError) {
      return `${ts('cash')}, ${ts('chk-bill')}, ${ts('note')}, ${ts('credit-receivable')}의 총합이 ${ts('total-amount')}과 일치해야합니다`
    }
    return ''
  }

  @Watch('data', {deep: true})
  __data(value) {
    this.$emit('input', value)
  }

  mounted() {
    this.data = this.value
  }

  onHandlePurposeType() {
    this.$emit('add-datalayer-extra-data', '청구/영수 정보')
  }

  onHandleAmountValue(event) {
    const value = event?.target?.value
    if(value) {
      this.$emit('add-datalayer-extra-data', '금액 상세 정보')
    }
  }
}
